import * as React from "react";
import CustomTextInput from './components/CustomTextInput';
import {
    List,
    Datagrid,
    TextField,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    ImageInput,
    ImageField,
    NumberInput,
    useTranslate
} from 'react-admin';
import { DefaultEditCreateActions, DefaultListActions, DefaultPagination, DefaultListPerPage } from '../lib/defaultConfig';
import { DefaultFilterSidebar, IdFilter } from "../components/ListFilters";

export const StoryList = props => (
    <List {...props} actions={<DefaultListActions />} pagination={<DefaultPagination />}
        perPage={DefaultListPerPage}
        aside={<DefaultFilterSidebar>
            <IdFilter />
        </DefaultFilterSidebar>}
    >
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="position"/>
            <TextField source="name" />
            <TextField source="title" />            
        </Datagrid>
    </List>
);

const CustomSimpleForm = props => {
    const t = useTranslate();

    return (<SimpleForm {...props}>
        <TextInput source="title" fullWidth />
        <TextInput source="name" fullWidth />
        <CustomTextInput source="desc" label={t('resources.stories.fields.desc', { _: 'Description' })} />
        <CustomTextInput source="content" label={t('resources.stories.fields.content', { _: 'Content' })} />
        <NumberInput source="position" min="0" />
        <ImageInput source="image" accept="image/*">
            <ImageField source="src" title="title" />
        </ImageInput>
    </SimpleForm>)
};

export const StoryEdit = props => (
    <Edit {...props} actions={<DefaultEditCreateActions/>} mutationMode={'pessimistic'}>
        {<CustomSimpleForm />}
    </Edit>
);
export const StoryCreate = props => (
    <Create {...props} actions={<DefaultEditCreateActions/>}>
        {<CustomSimpleForm />}
    </Create>
);